import { ProductData } from "@ts/components/ProductData";

let productData;

export const init = () => {
    setVariationOptions();
    loadProductData();
    setImageViewer();
}

const enableProductDetailSelectors = () => {
    document.querySelectorAll('.product-detail-container [data-loading]').forEach(element => {
        element.removeAttribute('data-loading');
    });
}

const loadProductData = async () => {
    const variationUrl = document.querySelector('.product-variations')?.dataset.variationUrl;
    if (!variationUrl) {
        enableProductDetailSelectors();
        return;
    }
    const defaultVariantId = document.querySelector('input[name="ProductVariantId"]')?.getAttribute('value');
    productData = await ProductData.create(variationUrl, {
        defaultVariantId: defaultVariantId,
        onLoad: (data) => {
            setPrice(data.getPrice());
            setSavings(data.getSavings());
            setSelectors(data);
            enableProductDetailSelectors();
        }
    });
}

const updateProductData = (variantId) => {
    productData.setActiveVariant(variantId);
}

const setSelectors = (data) => {
    let firstPass = true;
    const variations = document.querySelectorAll('.product-variation');
    variations.forEach(variation => {
        const optionId = variation.getAttribute('data-product-option-id');
        const availableChoices = data.getAvailableChoices(optionId).map(c => c.choiceId);
        const choices = variation.querySelectorAll('.variation-option');
        
        choices.forEach(choice => {
            const choiceId = choice.querySelector('input[type="radio"]').getAttribute('value');
            if (availableChoices.includes(choiceId) || firstPass) {
                choice.querySelector('input[type="radio"]').removeAttribute('disabled');
                choice.classList.remove('unavailable');
            } else {
                choice.querySelector('input[type="radio"]').setAttribute('disabled', 'true');
                choice.classList.add('unavailable');
            }
            if (data.activeVariant && data.activeVariant.choices.some(c => c.optionId === optionId && c.choiceId === choiceId)) {
                choice.querySelector('input[type="radio"]').checked = true;
            }
        });
        firstPass = false;
    });
}

const setSavings = (savings) => {
    const savingsContainer = document.querySelector('.product-savings');
    if (!savingsContainer) return;
    if (savings > 0) {
        savingsContainer.removeAttribute("hidden");
        document.querySelector('.total-savings').textContent = savings.toFixed(2);
    } else {
        savingsContainer.setAttribute("hidden", "true");
    }
}   

const setPrice = (price) => {
    const priceContainer = document.querySelector('.product-price');
    if (priceContainer && price) {
        priceContainer.textContent = `$${price.toFixed(2)}`;
    }
}

const setVariationOptions = () => {
    const radios = document.querySelectorAll('.variation-option input[type="radio"]');
    radios.forEach(radio => radio.addEventListener('change', handleVariationChange));
}

const gatherSelectedOptions = () => {
    const snapshot = {};
    const selectedRadios = document.querySelectorAll('.variation-option input[type="radio"]:checked');
    Array.from(selectedRadios).forEach(radio => {
        const optionId = radio.closest('.product-variation')?.getAttribute('data-product-option-id');
        const choiceId = radio.getAttribute('value');
        if (optionId) snapshot[optionId] = choiceId;
    });
    return snapshot;
}

const deselectAllRadios = () => {
    const allRadios = document.querySelectorAll('.variation-option input[type="radio"]');
    allRadios.forEach(radio => { radio.checked = false; });
}

const handleVariationChange = (event) => {
    const selectedOption = event.target.closest('.variation-option');

    // Get Snapshot of current selections
    const snapshot = gatherSelectedOptions();
    deselectAllRadios();

    // Build new selection map
    const changedRadio = event.target;
    const changedOptionId = changedRadio.closest('.product-variation')?.getAttribute('data-product-option-id');
    const changedChoiceId = changedRadio.getAttribute('value');

    // Set the changed radio as checked
    changedRadio.checked = true;

    // Find all variants that match the changed selection for the changed option
    let validVariants = [];
    if (productData && productData.data && productData.data.variants) {
        validVariants = productData.data.variants.filter(variant =>
            variant.choices.some(c => c.optionId === changedOptionId && c.choiceId === changedChoiceId)
        );
    }

    // For each other option group, try to restore the user's previous selection if it exists in any valid variant
    const variations = document.querySelectorAll('.product-variation');
    variations.forEach(variation => {
        const optionId = variation.getAttribute('data-product-option-id');
        if (!optionId || optionId === changedOptionId) return;
        const prevChoiceId = snapshot[optionId];
        if (!prevChoiceId) return;
        // Is this choiceId available in any valid variant?
        const isAvailable = validVariants.some(variant =>
            variant.choices.some(c => c.optionId === optionId && c.choiceId === prevChoiceId)
        );
        if (isAvailable) {
            const radio = variation.querySelector(`input[type="radio"][value="${prevChoiceId}"]`);
            if (radio) radio.checked = true;
        }
    });

    // Now update productData to match the new selection
    const selectedMap = gatherSelectedOptions();
    let match = null;
    if (productData && productData.data && productData.data.variants) {
        match = productData.data.variants.find(variant =>
            Object.entries(selectedMap).every(([optionId, choiceId]) =>
                variant.choices.some(c => c.optionId === optionId && c.choiceId === choiceId)
            )
        );
        if (match) {
            updateProductData(match.id);
            const variationIdInput = document.querySelector('input[name="ProductVariantId"]');
            if (variationIdInput) variationIdInput.setAttribute('value', match.id);
        }
    }
    setSelectors(productData);
    setPrice(productData.getPrice());
    setSavings(productData.getSavings());
    setImages(productData.getImages());
    checkForVariationDescriptions(selectedOption);
}

const setImages = (images = []) => {
    const defaultImage = images.find(image => image.isDefault) ?? images[0];
    setMainImage(defaultImage?.detailUrl);

    const galleryContainer = document.querySelector('.product-gallery');
    if (!galleryContainer) return;
    galleryContainer.replaceChildren();
    
    images.forEach(image => {
        const { cartUrl, detailUrl, isDefault } = image;
        const newGalleryItem = `
            <div class="gallery-item ${isDefault ? 'active' : ''}">
                <a href="${detailUrl}">
                    <img src="${cartUrl}" class="img-fluid" ${isDefault ? 'data-default' : ''}>
                </a>
            </div>
        `;
        galleryContainer.insertAdjacentHTML('beforeend', newGalleryItem);
    });
    setImageViewer();
}   

const setImageViewer = () => {
    const galleryTriggers = document.querySelectorAll('.gallery-item a');
    galleryTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            const galleryItems = document.querySelectorAll('.gallery-item');
            galleryItems.forEach(item => item.classList.remove('active'));
            trigger.closest('.gallery-item').classList.add('active');
            const imageUrl = trigger.getAttribute('href');
            setMainImage(imageUrl);
        });
    });
}

const setMainImage = (imageUrl) => {
    const mainImage = document.getElementById('product-detail-image');
    if (!mainImage) return;
    mainImage.setAttribute('src', imageUrl);
}

const checkForVariationDescriptions = (selectedOption) => {
    const variationDescription = selectedOption.querySelector('.variation-option-description');
    const variationDescriptionContainer = selectedOption.closest('.product-variation').querySelector('.variation-description');
    if (!variationDescriptionContainer) return;
    
    if (variationDescription) {
        variationDescriptionContainer.replaceChildren(variationDescription.content.cloneNode(true));
    } else {
        variationDescriptionContainer.replaceChildren();
    }
}